// @flow

import React, { type Node } from 'react';

import { PaymentSpecProvider } from '@tectonics/prs/payment-spec';
import { IncomingPaymentProvider } from '@tectonics/prs/incoming-payment';
import { type LookAndFeelRootPropsConfirmedPayment } from '@tectonics/look-and-feel';

type Props = {
  ...LookAndFeelRootPropsConfirmedPayment,
  children: Node,
};

export function ContextProvider({ children, ...context }: Props): Node {
  return (
    <PaymentSpecProvider spec={context.spec}>
      <IncomingPaymentProvider incomingPayment={context.incomingPayment}>
        {children}
      </IncomingPaymentProvider>
    </PaymentSpecProvider>
  );
}
